export default "__VITE_PUBLIC_ASSET__86c0815f__"